import React from 'react';
import css from '../less/index.m.less';
import cx from 'classnames';
import Swiper from '../../Utils/swiper.c';
import '../less/swiper.less';

export default function template() {
    const {model, title, emptyList, cardsList, newCardModels} = this.props,
        Component = this.props.component;
    let controls = null,
        content = null;

    // Check if we have new card models to display
    const hasNewModels = newCardModels && newCardModels.length > 0;

    if (hasNewModels) {
        content = (
            <Swiper
                spaceBetween={24}
                slidesPerView={3}
                slidesPerGroup={3}
                elementRef={this._swiperRef}
                threshold={20}
            >
                {/* Render only new card models, not using collection cards */}
                {newCardModels.map(newCardModel => {
                    const hashPan = newCardModel.get('hashPan'),
                        // Find the original card data for additional attributes
                        newCardAttr = cardsList.find(el => el.hashPan === hashPan) || {};

                    return (
                        <div
                            key={`card-${newCardModel.id || hashPan}`}
                            onClick={() => this.setActive(newCardModel)}
                        >
                            <Component
                                {...this.props}
                                newCardAttr={newCardAttr}
                                model={newCardModel}
                                active={newCardModel === model}
                            />
                        </div>
                    );
                })}
            </Swiper>
        );

        // Show navigation controls if there are more than 3 cards
        if (newCardModels.length > 3) {
            controls = (
                <>
                    <div className={cx(css.navigation, css.left)} onClick={this.prev} />
                    <div className={cx(css.navigation, css.right)} onClick={this.next} />
                </>
            );
        }
    } else {
        content = <p>{emptyList}</p>;
    }

    return (
        <div>
            <div className={css.heading}>
                <div className={css.title}>{title}</div>
                <div className={css.controls}>{controls}</div>
            </div>
            <div className={css.listWrapper}>
                <div className={css.list}>{content}</div>
            </div>
        </div>
    );
}
